







































import Vue from 'vue';
import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import ChristmasCalendarButton
  from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarButton.vue';
import PriceText from '@/components/newsingleproductpage/subcomponents/pricetext/PriceText.vue';
import { ECalendarDoorTypes } from '@/common/enums/announcement-bar.enum';

interface IChristmasCalendarProductDoorComponent {
  ECalendarDoorTypes: typeof ECalendarDoorTypes;
}

export default Vue.extend({
  name: `ChristmasCalendarProductDoor`,
  components: { ChristmasCalendarButton, PriceText },
  data(): IChristmasCalendarProductDoorComponent {
    return {
      ECalendarDoorTypes,
    };
  },
  computed: {
    buttonLabel(): string {
      if(this.oneProductOnOffer) {
        return this.$t(`announcement-bar-ufe:calendar.productDoor.goToOffer`);
      }
      return this.$t(`announcement-bar-ufe:calendar.productDoor.goToOffers`);
    },
    buttonLink(): string {
      if(this.oneProductOnOffer) {
        return this.content.products?.[0].link ?? ``;
      }
      return `/angebote/`;
    },
    description(): string {
      if(this.oneProductOnOffer) {
        return this.$t(this.content.products?.[0].description ?? ``);
      }
      return this.$t(`announcement-bar-ufe:calendar.${this.content.locizeIdentifier}.text`);
    },
    oneProductOnOffer(): boolean {
      return this.content.products?.length === 1;
    },
  },
  props: {
    content: {
      required: true,
      type: Object as () => ICalendarDoor,
    },
    isDesktopView: {
      required: false,
      type: Boolean,
    },
    logoPath: {
      required: true,
      type: String,
    },
  },
  methods: {
    navigateToOffer(): void {
      window.location.href = this.buttonLink;
    },
  },
});
